import React from 'react';
import PropTypes from 'prop-types';
import { get, isFunction, isString } from 'lodash';
import clxBind from 'classnames/bind';
import MaskedInput from 'react-text-mask';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Input extends React.Component {
  static propTypes = {
    mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
    mode: PropTypes.oneOf(['info', 'success', 'danger', 'warning']),
    guide: PropTypes.bool,
    unmaskValue: PropTypes.bool,
    maskPlaceholderChar: PropTypes.string,
    inputRef: PropTypes.func,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    mask: undefined,
    mode: undefined,
    readOnly: false,
    disabled: false,
    unmaskValue: true,
    maskPlaceholderChar: '_',
    inputRef: undefined,
    guide: true,
    onChange: undefined,
    onBlur: undefined,
    className: undefined,
  };

  createHandler(cb) {
    const { unmaskValue } = this.props;

    if (!unmaskValue) {
      return cb;
    }

    return event => {
      let value = get(event, 'target.value');

      if (value && unmaskValue) {
        value = this.unmask(value);
      }

      cb(value);
    };
  }

  unmask(value) {
    const { mask, maskPlaceholderChar, guide } = this.props;

    let maskChunks = mask;
    let unmasked = '';

    if (isFunction(mask)) {
      maskChunks = mask(value);
    }

    maskChunks.forEach((m, index) => {
      const v = get(value, `[${index}]`);

      if (!isString(m) && v && (v !== maskPlaceholderChar || !guide)) {
        unmasked += v;
      }
    });

    return unmasked;
  }

  renderInput = (ref, props) => {
    const { inputRef } = this.props;

    return (
      <input
        ref={input => {
          if (isFunction(inputRef)) {
            inputRef(input);
          }
          ref(input);
        }}
        {...props}
      />
    );
  };

  render() {
    const {
      mask,
      unmaskValue,
      mode,
      guide,
      maskPlaceholderChar,
      inputRef,
      disabled,
      readOnly,
      className,
      ...props
    } = this.props;

    const inputClasses = clx('input', className, {
      [`mode-${mode}`]: mode,
      readonly: readOnly,
      disabled,
    });

    if (mask) {
      const { onChange, onBlur } = this.props;

      const handleChange = isFunction(onChange) ? this.createHandler(onChange) : undefined;
      const handleBlur = isFunction(onBlur) ? this.createHandler(onBlur) : undefined;

      return (
        <MaskedInput
          mask={mask}
          guide={guide}
          placeholderChar={maskPlaceholderChar}
          className={inputClasses}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={disabled}
          readOnly={readOnly}
          render={this.renderInput}
          {...props}
        />
      );
    }

    return (
      <input
        className={inputClasses}
        readOnly={readOnly}
        disabled={disabled}
        ref={inputRef}
        {...props}
      />
    );
  }
}
